import { ReplaceVirtuallyFormState } from '../constants';
import { ReplaceVirtuallyFormSubmissionEvent } from '@/app/api/revent/types';
import logError from '@/helpers/logError';

export type HubspotDealInfoRevent = { dealId: string };

export const reventEvent = async (
	state: ReplaceVirtuallyFormState,
	hubspotDealInfo?: HubspotDealInfoRevent,
) => {
	const body: ReplaceVirtuallyFormSubmissionEvent = {
		address: state.address,
		downloadUrl: '',
		email: state.email,
		experience: state.experience,
		firstName: state.firstName,
		hubspotContactId: state.hubspotContactId,
		hubspotDealId: hubspotDealInfo?.dealId || '',
		hubspotFolderId: state.hubspotFolderId,
		lastName: state.lastName,
		message: state.message,
		modelNumber: state.modelNumber,
		modelSize: state.modelSize,
		modelType: state.modelType,
		phone: state.phone,
		projectDetails: state.projectDetails,
		referenceID: state.referenceId,
		referralSource: state.referralSource,
		sessionId: state.sessionId,
		systemAge: state.systemAge,
		systemIssues: state.systemIssues,
		systemLocation: state.systemLocation,
	};

	try {
		await fetch('/api/revent', {
			method: 'POST',
			body: JSON.stringify(body),
		})
			.then((response) => {
				return response.json();
			})
			.catch((error) => {
				if (error instanceof Error) {
					logError(error);
				}
			});
	} catch (error) {
		logError(
			error instanceof Error
				? error
				: new Error('Unknown error occurred with reventEvent call'),
		);
	}
};
